import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';
import { useTranslations } from 'next-intl';
import track from '@helper/tracking';
import { navReset } from '../../../redux/actions/navigation';
import { searchReset } from '../../../redux/actions/search';
import {
  accessibilityReset,
  accessibilityIsOpenToggle
} from '../../../redux/actions/accessibility';

import StyledAccessibilityButton from './accessibilityButton.style';

import AccessibilityIcon from '../../icons/accessibilityIcon.svg';
import CloseIcon from '../../icons/close.svg';

const AccessibilityButton = ({
  accessibilityIsOpen,
  navIsOpen,
  close,
  resetAccessibility,
  searchIsOpen,
  handleOpen,
  inverted = false,
  ...props
}) => {
  const t = useTranslations();
  useEffect(() => {
    Router.events.on('beforeHistoryChange', resetAccessibility);

    return () => {
      Router.events.off('beforeHistoryChange', resetAccessibility);
    };
  });
  const Icon = close ? CloseIcon : AccessibilityIcon;

  return (
    <StyledAccessibilityButton
      type="button"
      title={accessibilityIsOpen ? t('accessibilityMeta.close') : t('accessibilityMeta.open')}
      aria-haspopup="menu"
      aria-expanded={accessibilityIsOpen ? 'true' : 'false'}
      onClick={() => {
        track(['trackEvent', 'Accessibility Icon', 'Click']);
        handleOpen(accessibilityIsOpen, navIsOpen, searchIsOpen);
      }}
      {...props}
      inverted={inverted}
      close={close}
    >
      <Icon width={35} aria-hidden="true" />
      <span className="sr-only">
        {accessibilityIsOpen ? t('accessibilityMeta.close') : t('accessibilityMeta.open')}
      </span>
    </StyledAccessibilityButton>
  );
};

AccessibilityButton.propTypes = {
  navIsOpen: PropTypes.bool.isRequired,
  searchIsOpen: PropTypes.bool.isRequired,
  accessibilityIsOpen: PropTypes.bool.isRequired,
  close: PropTypes.bool,
  inverted: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  resetAccessibility: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  navIsOpen: state.navigation.isOpen,
  searchIsOpen: state.search.isOpen,
  accessibilityIsOpen: state.accessibility.isOpen
});

const mapDispatchToProps = dispatch => ({
  handleOpen: (accessibilityIsOpen, navIsOpen, searchIsOpen) => {
    dispatch(accessibilityIsOpenToggle());

    if (accessibilityIsOpen) {
      dispatch(accessibilityReset());
    }

    if (navIsOpen) {
      dispatch(navReset());
    }

    if (searchIsOpen) {
      dispatch(searchReset());
    }
  },
  resetAccessibility: () => dispatch(accessibilityReset())
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityButton);
